import Preset from './_default';

export default class Brooklyn extends Preset {
    name = 'Venture';

    // override the default Preset here
}
